// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    borderRadius: 15,
    width: 150,
    height: '80%',
    backgroundColor: GlobalStyles.color.COLOR_DEFAULT,
    [theme.breakpoints.down(400)]: {
      height: 200,
      width: '100%',
      boxShadow: 'none',
      borderRadius: 0,
    },
  },
});

export default styles;
